import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_API_URL;
console.log("ajkfiuhwefih", API_BASE_URL, localStorage.getItem("token"))

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

export default api;
